import React from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

interface CreateUserButtonProps {
    onClick?: () => void;
}

const CreateUserButton: React.FC<CreateUserButtonProps> = ({ onClick }) => {
    return (
        <Button variant="contained" startIcon={<AddIcon />} onClick={onClick}>
            Create New User
        </Button>
    );
};

export default CreateUserButton;
